import "../../../assets/scss/docs-style.scss";
import { useTranslation } from "react-i18next";

export const Docs = () => {
  const { t } = useTranslation();

  return (
    <div className="wrapper docs-info">
      <h3>Rental Process</h3>

      <h4>1. Choose the GPU Type</h4>
      <p>
        We offer a variety of GPUs, including <b>H100, 6000 Ada, 4090</b>, and
        more, to meet your AI computing needs.
      </p>
      <img
        src="./images/docs/gpu-selection.png"
        alt="GPU selection"
        className="docs-img"
      />

      <h4>2. Choose the Template and Start Rental</h4>
      <p>
        We offer a wide range of templates designed for different AI
        environments — such as training, inference, and image generation.
      </p>
      <img
        src="./images/docs/template-selection.png"
        alt="Template selection"
        className="docs-img"
      />
      <p>Select your desired AI application from the list.</p>
      <img
        src="./images/docs/app-selection.png"
        alt="Application selection"
        className="docs-img modal"
      />
      <p>
        Choose the number of GPUs you wish to rent and click{" "}
        <b>“Start Rental”</b> to begin.
      </p>
      <img
        src="./images/docs/start-rental.png"
        alt="Start rental"
        className="docs-img"
      />
      <p>
        You can monitor <b>instance initialization</b> in real-time from the
        dashboard.
      </p>
      <img
        src="./images/docs/instance-init.png"
        alt="Instance initialization"
        className="docs-img"
      />
      <p>
        All active instances and their statuses are listed under the{" "}
        <b>Instances</b> section.
      </p>

      <h4>3. Use Services</h4>
      <img
        src="./images/docs/instance-card.png"
        alt="Instance card"
        className="docs-img"
      />
      <p>Click a card to view detailed information for each instance.</p>
      <img
        src="./images/docs/instance-details.png"
        alt="Instance details"
        className="docs-img modal"
      />
      <p>
        Once ready, click <b>“Use Services”</b> to activate the selected AI
        application service.
      </p>
      <img
        src="./images/docs/use-service.png"
        alt="Use service"
        className="docs-img"
      />
      <p>
        The SSH connection address and access password will also be provided for
        you to connect directly.
      </p>

      <hr />

      <h3>Google Drive Integration</h3>

      <h4>1. Bind Google Drive</h4>
      <p>
        Click <b>“Connect Google Drive”</b> in the NeuroPlus Cloud panel. A
        Google login window will appear. After authorizing access, your Google
        Drive will be linked to your NeuroPlus account.
      </p>
      <img
        src="./images/docs/google-drive-bind.png"
        alt="Google Drive binding"
        className="docs-img"
      />

      <h4>2. Download Files from Google Drive to Instance</h4>
      <p>
        In the <b>Google Drive</b> section, right-click on any file and choose{" "}
        <b>“Download to Instance”</b>. The file will automatically transfer to
        your selected NeuroPlus instance.
      </p>
      <img
        src="./images/docs/google-drive-download.png"
        alt="Download from Drive to Instance"
        className="docs-img"
      />

      <h4>3. Upload Files from Instance to Google Drive</h4>
      <p>
        Inside your instance’s file manager, right-click on any file and select{" "}
        <b>“Upload From Instance to Google Drive”</b>. The file will be securely
        uploaded to your linked Google Drive account.
      </p>
      <img
        src="./images/docs/instance-upload.png"
        alt="Instance upload to Drive"
        className="docs-img"
      />
      <img
        src="./images/docs/instance-upload-2.png"
        alt="Instance upload to Drive"
        className="docs-img"
      />

      <hr />

      <h3>SSH Connection (via VS Code)</h3>
      <p>
        You can connect to your NeuroPlus instance using{" "}
        <b>Visual Studio Code’s Remote SSH</b> feature.
      </p>

      <ol>
        <li>Open Visual Studio Code.</li>
        <li>Install the “Remote - SSH” extension if not already installed.</li>
        <li>
          Press <b>F1</b> (or Cmd/Ctrl + Shift + P) → Search “Remote-SSH”.
        </li>
        <li>
          Enter the SSH command provided in your instance details, e.g.:
          <div className="code">ssh user@123.45.67.89 -p 22</div>
        </li>
        <li>
          When prompted, enter the password shown in your NeuroPlus instance
          info card.
        </li>
      </ol>

      <p>
        Once connected, you can open files, edit code, and run commands directly
        from VS Code as if you were operating inside the remote machine.
      </p>

      <blockquote>
        Tip: For security, remember to terminate your SSH session after
        completing your work.
      </blockquote>
    </div>
  );
};
